export const PROTOCOL_ENTITY_TYPE = 'qpcr-protocol';

export default PROTOCOL_ENTITY_TYPE;
